<template>
  <v-card width="100%" class="ma-0 pa-2 mt-2" elevation="0" outlined>
    <v-card-title class="blue--text pa-0 ma-0 ml-1 mb-2">Ball</v-card-title>
    <v-row dense>
      <v-col cols="12" sm="4" md="4">
        <v-text-field v-model.trim="value.key" label="Key" hide-details/>
      </v-col>
      <v-col cols="12" md="4" sm="4">
        <r-currency-kind-dropdown :model.sync="value.currency" />
      </v-col>
      <v-col cols="12" sm="2" md="2" class="mx-3">
        <v-btn @click="onPhysicsConfig" small color="success" class="my-1 fill-width">
          Physics Config
        </v-btn>
      </v-col>
    </v-row>
    <r-plinko-physics-config-dialog ref="r-plinko-physics-config"/>
  </v-card>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {PlinkoBallConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoBallConfig";
import RPlinkoPhysicsConfigDialog from "@/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-physics-config-dialog.vue";
import RCurrencyKindDropdown from "@/modules/redactor/views/currency-kind/r-currency-kind-dropdown.vue";

export default {
  name: "r-plinko-ball-config",
  components: {RCurrencyKindDropdown, RPlinkoPhysicsConfigDialog},
  props: {
    model: VueTypes.instanceOf(PlinkoBallConfig)
  },
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new PlinkoBallConfig();
        this.$emit("update:model", value);
        return value;
      }
    }
  },
  methods: {
    onPhysicsConfig() {
      let data = this.value.physicsConfig ? this.value.physicsConfig.clone() : null;
      this.$refs['r-plinko-physics-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.physicsConfig = data;
      }).catch(() => {
      });
    }
  }
}

</script>